// extracted by mini-css-extract-plugin
module.exports = {"container":"Article_container__bZHBY","title":"Article_title__3VWzd","description":"Article_description__NcDDE"};